import {z} from '@hono/zod-openapi'
import { AddressValueSchema } from '@next-is-free-monorepo/next-is-free-types';

export const billingDataSchema = z.object({
  vat: z.string(),
  legal_name: z.string(),
  billing_address: AddressValueSchema,
  sdi_code: z.string(),
  tax_code: z.string().nullish(),
})

export type BillingData = z.infer<typeof billingDataSchema>
